import { put, takeLatest } from 'redux-saga/effects';
import {
  APP_DETAILS,
  APP_RECOMMEND_URL,
  SEARCH_RECOMMEND_NEW_61,
  GROUNP_CONTENT_53,
  APP_DETAILS_70,
  APP_DETAILS_GIFT_70,
  APP_DETAILS_GIFT_RECEIVE_70,
  APP_FORUM_RELATED_74,
} from '../config';
import {
  APP_DETAILS_REQUEST,
  APP_DETAILS_SUCCESS,
  APP_RECOMMEND_REQUEST,
  APP_RECOMMEND_SUCCESS,
  APP_GROUP_SUCCESS,
  APP_GROUP_REQUEST,
  APP_DETAILS_GIFT_REQUEST,
  APP_DETAILS_GIFT_SUCCESS,
  APP_DETAILS_GIFT_RECEIVE_REQUEST,
  APP_DETAILS_GIFT_RECEIVE_SUCCESS,
  APP_FORUM_RELATED_REQUEST,
  APP_FORUM_RELATED_SUCCESS,
} from '../constants/detail';
import { createAxios } from '../utils/utils';
import React from 'react';
import { message } from 'antd';
import success from '../static/msg-success.svg';
import fail from '../static/msg-fail.svg';

function* fetchAppDetails({ softid = '', bizInfo = {} }) {
  try {
    const axios = yield createAxios('isNeedUser');
    const res = yield axios.get(APP_DETAILS_70, { params: { softid, bizInfo: bizInfo || {} } });
    if (res.data.status === 0) {
      yield put({
        type: APP_DETAILS_SUCCESS,
        payload: { ...res.data.data, paramSoftId: softid, loading: false },
      });
    } else {
      yield put({
        type: APP_DETAILS_SUCCESS,
        payload: { ...res.data, paramSoftId: softid, loading: false },
      });
    }
  } catch (error) {
    // throw error;
  }
}

function* fetchAppRecommend({ softInfo, androidType, source }) {
  try {
    const axios = yield createAxios();
    const res = yield axios.get(SEARCH_RECOMMEND_NEW_61, {
      params: { softInfo, androidType, source },
    });
    if (res.data.status === 0) {
      yield put({
        type: APP_RECOMMEND_SUCCESS,
        payload: { ...res.data.data, softInfo, androidType, source },
      });
    }
  } catch (error) {
    // throw error;
  }
}

export function* watchAppDetails() {
  yield takeLatest(APP_DETAILS_REQUEST, fetchAppDetails);
}
export function* watchAppRecommend() {
  yield takeLatest(APP_RECOMMEND_REQUEST, fetchAppRecommend);
}

/**
 * 其他推荐group
 */
function* fetchGroupContent(params) {
  try {
    const axios = yield createAxios();
    const res = yield axios.get(GROUNP_CONTENT_53, {
      params: {
        pageType: params.pageType,
        ztType: params.ztType,
      },
    });

    if (res.data && res.data.status === 0) {
      yield put({
        type: APP_GROUP_SUCCESS,
        payload: {
          dataList: [...res.data.data],
          ...params,
        },
      });
    }
  } catch (error) {
    // throw error;
  }
}
export function* watchFetchGroupContent() {
  yield takeLatest(APP_GROUP_REQUEST, fetchGroupContent);
}

/**
 * 获取礼包list
 */
function* fetchDetailGiftList({ softInfo, androidType }) {
  try {
    const axios = yield createAxios('isNeedUser');
    const res = yield axios.get(APP_DETAILS_GIFT_70, {
      params: { softInfo, androidType },
    });

    if (res.data && res.data.status === 0) {
      yield put({
        type: APP_DETAILS_GIFT_SUCCESS,
        payload: {
          dataList: [...res.data.data],
          softInfo,
        },
      });
    }
  } catch (error) {
    // throw error;
  }
}
export function* watchFetchDetailGiftList() {
  yield takeLatest(APP_DETAILS_GIFT_REQUEST, fetchDetailGiftList);
}

/**
 * 领取单个礼包
 */
function* fetchReceiveGift(params) {
  try {
    yield put({
      type: APP_DETAILS_GIFT_RECEIVE_SUCCESS,
      payload: {
        loading: true,
        ...params,
      },
    });
    const axios = yield createAxios('isNeedUser');
    const res = yield axios.get(APP_DETAILS_GIFT_RECEIVE_70, {
      params,
    });

    if (res.data) {
      if (res.data.status === 0) {
        message.success({
          content: res.data.message,
          className: 'ant-message-notice-center',
          icon: <img className="ant-message-custom-img" src={success} alt="fail" />,
        });
      } else {
        message.error({
          content: res.data.message,
          icon: <img className="ant-message-custom-img" src={fail} alt="success" />,
        });
      }
    }

    if (res.data) {
      yield put({
        type: APP_DETAILS_GIFT_RECEIVE_SUCCESS,
        payload: {
          loading: false,
          data: res.data,
          ...params,
        },
      });
    }
  } catch (error) {
    // throw error;
  }
}
export function* watchFetchReceiveGift() {
  yield takeLatest(APP_DETAILS_GIFT_RECEIVE_REQUEST, fetchReceiveGift);
}

/**
 * 领取单个礼包
 */
function* fetchAppForumRelated(params) {
  try {
    const axios = yield createAxios();
    const res = yield axios.get(APP_FORUM_RELATED_74, {
      params: params.payload,
    });

    if (res.data.status === 0) {
      yield put({
        type: APP_FORUM_RELATED_SUCCESS,
        payload: {
          ...params.payload,
          forumList: (res.data.data && res.data.data.forumContentList) || [],
        },
      });
    } else {
      yield put({
        type: APP_FORUM_RELATED_SUCCESS,
        payload: {
          ...params.payload,
          forumList: [],
        },
      });
    }
  } catch (error) {
    yield put({
      type: APP_FORUM_RELATED_SUCCESS,
      payload: {
        ...params.payload,
        forumList: [],
      },
    });
  }
}
export function* watchFetchAppForumRelated() {
  yield takeLatest(APP_FORUM_RELATED_REQUEST, fetchAppForumRelated);
}
